import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import styled from 'styled-components/macro';
import { theme } from 'styled-tools';
import { AwardIcon } from 'components/Icons';
import { formatModuleRunningTime } from 'utils/functions';

const Cert = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  svg {
    margin-right: 0;
    color: ${theme('colors.primary')};
  }
`;

const ModuleInfoWrapper = styled(Row)`
  font-size: 0.75rem;
  justify-content: flex-start;
  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    &:first-of-type {
      padding-left: 0;
    }
  }
  p {
    margin-bottom: 0;
  }
`;

const Label = styled.label`
  color: ${theme('colors.darkerGray')};
`;

function ModuleInfo({ playingTimeInSeconds, quiz, learningCredits, hasIsbeCompletionCertificate }) {
  return (
    <ModuleInfoWrapper>
      {playingTimeInSeconds && (
        <Col md={3}>
          <p aria-label='Running Time'>{formatModuleRunningTime(playingTimeInSeconds)}</p>
          <Label>Running Time</Label>
        </Col>
      )}
      <Col md={2}>
        <p aria-label='Credits Earned'>{learningCredits}</p>
        <Label>Credits</Label>
      </Col>
      {quiz && quiz.enabled && (
        <>
          {hasIsbeCompletionCertificate && (
            <Col md={2}>
              <Cert>
                <AwardIcon title='ISBE Certificate' />
                <Label>ISBE</Label>
              </Cert>
            </Col>
          )}
          <Col md={2}>
            <Cert>
              <AwardIcon title='Certificate of Completion' />
              <Label>COC</Label>
            </Cert>
          </Col>
        </>
      )}
    </ModuleInfoWrapper>
  );
}

ModuleInfo.propTypes = {
  playingTimeInSeconds: PropTypes.string,
  hasIsbeCompletionCertificate: PropTypes.string,
  learningCredits: PropTypes.string,
  quiz: PropTypes.shape({
    enabled: PropTypes.bool,
  }),
};

export default ModuleInfo;
